import React, { useContext } from 'react';
import Buttons from '../../../components/button/Buttons';
import TextWinds from '../../../components/common/TextWinds';
import Icon from '../../../components/common/Icon';
import { SignupContext } from './SignupContext';
import { useAppDispatch } from '../../../store/hook';
import { openAlert } from '../../../store/features/modalSlice';
import { useNavigate } from 'react-router-dom';
import HFinputPhone from '../../../components/common/input/HFinputPhone';
import HFbutton from '../../../components/button/HFbutton';
import HFinput from '../../../components/common/input/HFinput';
import useSmsHook from '../../../controllers/useSmsHook';
import { useForm } from 'react-hook-form';
import { timeLeftCheck, timeLeftToString } from '../../../controllers/useTimer';
import { isValidPhone, normalizePhone } from '../../../constants/validation';

type checkSignupByPhoneDTO = {
  verifySmsId: string;
  phone: string;
  verifyType: string;
};

const LoginCheck = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [verifyNumber, setVerifyNumber] = React.useState<string>('');
  const [isConfirmPhone, setIsConfirmPhone] = React.useState<boolean>(false);
  const [isConfirmCode, setIsConfirmCode] = React.useState<boolean>(false);
  const [isPossibleNext, setIsPossibleNext] = React.useState<boolean>(false);

  const { setPhone, step, setStep } = useContext(SignupContext);

  const { sendVerifyNumber, checkVerifyNumber, timeLeft } = useSmsHook();

  const { register, handleSubmit, watch, setValue } =
    useForm<checkSignupByPhoneDTO>();

  const openAlertWithMessage = (msg: string) => {
    dispatch(openAlert({ message: msg }));
  };

  const onSubmit = (data: checkSignupByPhoneDTO) => {
    data.verifyType = 'PHONE';

    if (data.verifySmsId === undefined) {
      dispatch(openAlert({ message: '전화번호 인증을 받아주세요.' }));
      return;
    }

    setPhone(normalizePhone(data.phone));
    setStep(step + 1);
  };

  // 인증번호 발송
  const sendSmsHandler = () => {
    setIsConfirmPhone(true);

    // 휴대폰 번호 유효성 검사
    if (!isValidPhone(watch('phone'))) {
      dispatch(
        openAlert({
          message: '휴대폰 번호는 숫자 01012345678 형식으로 입력해주세요.',
        }),
      );
      setIsConfirmPhone(false);
      return;
    }

    sendVerifyNumber(watch('phone')).then((msg) => {
      setIsConfirmPhone(false);
      openAlertWithMessage(msg);
    });
  };

  // 인증번호 확인
  const confirmSmsHandler = () => {
    setIsConfirmCode(true);

    checkVerifyNumber(watch('phone'), verifyNumber).then((res) => {
      if (res.confirm) {
        setIsConfirmPhone(true);
        setIsConfirmCode(true);
        setIsPossibleNext(true);
        setValue('verifySmsId', res.confirm.toString());
      } else {
        setIsConfirmCode(false);
      }
      openAlertWithMessage(res.msg);
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <TextInfoSection />
      <section className="flex flex-col gap-2">
        <div className="relative">
          <HFinputPhone
            label="휴대폰 번호"
            placeholder="휴대폰 번호를 입력해주세요."
            name="phone"
            register={register('phone', {
              required: { value: true, message: '휴대폰 번호를 입력해주세요.' },
            })}
            disabled={timeLeftCheck(timeLeft) || isConfirmCode}
          />
          <div className="absolute right-1 top-8">
            <HFbutton
              height={40}
              onClick={sendSmsHandler}
              disabled={timeLeftCheck(timeLeft) || isConfirmPhone}
            >
              {timeLeftCheck(timeLeft)
                ? timeLeftToString(timeLeft)
                : '인증번호'}
            </HFbutton>
          </div>
        </div>
        <div className="relative">
          <HFinput
            label="인증번호"
            type="text"
            placeholder="인증번호를 입력해주세요."
            value={verifyNumber}
            onChange={(e) => setVerifyNumber(e.target.value)}
            disabled={isConfirmCode}
          />
          <div className="absolute right-1 top-8">
            <HFbutton
              height={40}
              onClick={confirmSmsHandler}
              disabled={isConfirmCode}
            >
              {isConfirmCode ? '인증완료' : '인증확인'}
            </HFbutton>
          </div>
        </div>
        {timeLeftCheck(timeLeft) && (
          <TextWinds type="caption1" color="purple5" className="ml-2">
            카카오톡 알림톡에서 인증번호를 확인해주세요.
          </TextWinds>
        )}
      </section>
      <section className="flex flex-col gap-2">
        <Buttons
          type="filled"
          color={'purple5'}
          onClick={handleSubmit(onSubmit)}
          disabled={!isPossibleNext}
        >
          다음
        </Buttons>
        <Buttons
          type="outlined"
          color={'purple5'}
          onClick={() => navigate('/signin')}
        >
          취소
        </Buttons>
      </section>
    </div>
  );
};

const TextInfoSection = () => (
  <section>
    <div>
      <TextWinds type="title_h2">회원가입 확인</TextWinds>
      <TextWinds type="caption1">
        학생 계정 가입은 클래스 선생님에게 요청해 주세요.
      </TextWinds>
    </div>
    <div className="pb-[25px] pt-[35px] text-center">
      <div className="flex justify-center">
        <TextWinds type="title_h3" xlType="title_h2" color="gray9">
          안녕하세요~
        </TextWinds>
        <Icon width={28} height={28} fileName="icon_face" />
      </div>
      <div className="pt-[9px]">
        <TextWinds type="title_h4" color="purple5">
          먼저 휴대폰 번호를 확인해 주세요.
        </TextWinds>
      </div>
    </div>
  </section>
);

export default LoginCheck;
